// Erklaerungen fuer den Modus "Gerät kennenlernen".
// Hier steht kein Code, nur Text. Diese Datei darf jemand pflegen, der das
// Geraet kennt aber nicht programmiert.
//
// Aufbau: zwei Gruppen.
//   teile    — wo ist was am Geraet
//   ablaeufe — wie macht man etwas
// Beide haben dieselbe Form: { id, titel, schritte: [ ... ] }.
//
// Ein Schritt hat:
//   target   — was angeleuchtet wird. Ein Name oder eine Liste von Namen.
//   text     — was in der Blase steht.
//   zustand  — OPTIONAL. Stellt das Geraet so, dass das Display wirklich
//              zeigt, wovon der Text spricht. Gilt nur solange der Schritt
//              offen ist; beim Schliessen wird der echte Zustand
//              wiederhergestellt. Waehrend einer Erklaerung ist das Geraet
//              nicht bedienbar, das Bild bleibt also stehen.
//
// Felder, die `zustand` kennt:
//   isOn, channel, commMode ('D'/'G'), isTransmitting, battery, volume,
//   screen ('' | 'input' | 'list' | 'confirmOff'), pendingMode, listIndex
//
// Gueltige target-Namen:
//   Am Geraet:  power, volume, ptt
//   Im Display: screen, volumeBars, battery, signal, info, softkeys,
//               selectorD, selectorG, navUp, navDown, ok, digits, hangup
//
// Kanalnummern stammen aus Kanaele.js — 9003 ist "ZS 3" (Dir),
// 9102 ist "ZS KEE 1" (Grp).
//
// ACHTUNG: Die Formulierungen sind ein erster Entwurf und fachlich zu pruefen.

export const teile = [
    {
        id: 'display',
        titel: 'Das Display',
        schritte: [
            { target: 'screen', text: 'Auf dem Display steht alles, was das Gerät dir sagen will: Lautstärke, Akku, Signal und der Kanal, in dem du bist.' }
        ]
    },
    {
        id: 'ein_aus',
        titel: 'Ein- und ausschalten',
        schritte: [
            { target: 'power', text: 'Ein kurzer Druck schaltet das Gerät ein. Zum Ausschalten hältst du dieselbe Taste zwei Sekunden lang gedrückt.' }
        ]
    },
    {
        id: 'lautstaerke',
        titel: 'Lautstärke',
        schritte: [
            { target: 'volume', text: 'Mit dem Rad änderst du die Lautstärke: links leiser, rechts lauter. Bei ausgeschaltetem Gerät passiert nichts.' },
            { target: 'volumeBars', text: 'Oben im Display zeigen die Balken die Lautstärke, in sieben Stufen.', zustand: { volume: 5 } }
        ]
    },
    {
        id: 'akku',
        titel: 'Akkustand',
        schritte: [
            { target: 'battery', text: 'Diese Balken zeigen den Akkustand. Beim Senden sinkt er sichtbar, denn Senden braucht am meisten Strom.' }
        ]
    },
    {
        id: 'signal',
        titel: 'Signalstärke',
        schritte: [
            { target: 'signal', text: 'Hier zeigt das Gerät an, wie gut es das Netz empfängt. In dieser Simulation ist der Wert fest.' }
        ]
    },
    {
        id: 'kanalanzeige',
        titel: 'Kanalanzeige',
        schritte: [
            { target: 'info', text: 'Ohne Kanal steht hier «Nicht in Kom.». Dann hörst du niemanden, und niemand hört dich.', zustand: { channel: null, commMode: '' } },
            { target: 'info', text: 'Bist du in einem Kanal, steht hier die Art der Verbindung und die Kanalnummer.', zustand: { channel: '9003', commMode: 'D' } }
        ]
    },
    {
        id: 'softkeys',
        titel: 'Softkeys',
        schritte: [
            { target: 'softkeys', text: 'Diese drei Beschriftungen gehören zu den Tasten darunter. Was dort steht, ändert sich je nach Situation. Lies sie, bevor du drückst.' }
        ]
    },
    {
        id: 'auswahltasten',
        titel: 'Dir und Grp',
        schritte: [
            { target: 'selectorD', text: 'Die linke Taste gehört zur linken Beschriftung. Im Normalzustand ist das «Dir», also Direktverkehr von Gerät zu Gerät.' },
            { target: 'selectorG', text: 'Die rechte Taste gehört zur rechten Beschriftung, im Normalzustand «Grp», also Verkehr über eine Gruppe.' }
        ]
    },
    {
        id: 'navigation',
        titel: 'Blättern und bestätigen',
        schritte: [
            { target: 'navUp', text: 'Mit dieser Taste blätterst du in einer Liste nach oben.', zustand: { pendingMode: 'G', screen: 'list', listIndex: 1 } },
            { target: 'navDown', text: 'Mit dieser nach unten.', zustand: { pendingMode: 'G', screen: 'list', listIndex: 2 } },
            { target: 'ok', text: 'OK bestätigt, was gerade ausgewählt ist.', zustand: { pendingMode: 'G', screen: 'list', listIndex: 2 } }
        ]
    },
    {
        id: 'ziffern',
        titel: 'Zifferntasten',
        schritte: [
            { target: 'digits', text: 'Über die Zifferntasten gibst du eine Kanalnummer direkt ein. Sie tun erst etwas, wenn du vorher «Dir» oder «Grp» gedrückt hast. Sonst weiss das Gerät nicht, welche Art Kanal du meinst.', zustand: { pendingMode: 'D', screen: 'input' } }
        ]
    },
    {
        id: 'auflegen',
        titel: 'Auflegen-Taste',
        schritte: [
            { target: 'hangup', text: 'Die rote Taste beendet. Gedrückt gehalten verlässt sie den Kanal.', zustand: { channel: '9003', commMode: 'D' } }
        ]
    },
    {
        id: 'sprechtaste',
        titel: 'Sprechtaste (PTT)',
        schritte: [
            { target: 'ptt', text: 'Zum Sprechen hältst du die Taste gedrückt. Kurz drücken genügt nicht.', zustand: { channel: '9003', commMode: 'D' } },
            { target: 'info', text: 'Solange du sendest, steht im Display ein «T».', zustand: { channel: '9003', commMode: 'D', isTransmitting: true } }
        ]
    }
]


export const ablaeufe = [
    {
        id: 'kanal_nummer',
        titel: 'Kanal über die Nummer wählen',
        schritte: [
            { target: 'selectorD', text: 'Drücke «Dir» oder «Grp». Damit wählst du die Art des Kanals.' },
            { target: 'digits', text: 'Tippe die vierstellige Kanalnummer. Nach der vierten Ziffer übernimmt das Gerät sie von selbst.', zustand: { pendingMode: 'D', screen: 'input' } },
            { target: 'info', text: 'Jetzt steht oben, in welchem Kanal du bist.', zustand: { channel: '9003', commMode: 'D' } }
        ]
    },
    {
        id: 'kanal_liste',
        titel: 'Kanal aus der Liste wählen',
        schritte: [
            { target: 'selectorG', text: 'Drücke «Grp».' },
            { target: 'softkeys', text: 'Rechts steht jetzt «Durchsuchen». Darüber kommst du in die Kanalliste.', zustand: { pendingMode: 'G', screen: 'input' } },
            { target: 'selectorG', text: 'Drücke die rechte Taste unter «Durchsuchen».', zustand: { pendingMode: 'G', screen: 'input' } },
            { target: 'navDown', text: 'Jetzt siehst du die Kanäle. Blättere mit den Pfeiltasten zum gewünschten.', zustand: { pendingMode: 'G', screen: 'list', listIndex: 1 } },
            { target: 'ok', text: 'Mit OK trittst du ein.', zustand: { pendingMode: 'G', screen: 'list', listIndex: 1 } }
        ]
    },
    {
        id: 'kanal_erkennen',
        titel: 'Bin ich in einem Kanal?',
        schritte: [
            { target: 'info', text: 'Steht hier «Nicht in Kom.», bist du in keinem Kanal und niemand hört dich.', zustand: { channel: null, commMode: '' } },
            { target: 'info', text: 'Bist du in einem Kanal, steht hier «Dir» oder «Grp» und daneben die Kanalnummer.', zustand: { channel: '9102', commMode: 'G' } }
        ]
    },
    {
        id: 'kanal_verlassen',
        titel: 'Kanal verlassen',
        schritte: [
            { target: 'hangup', text: 'Halte die rote Taste rund anderthalb Sekunden gedrückt.', zustand: { channel: '9003', commMode: 'D' } },
            { target: 'info', text: 'Im Display steht wieder «Nicht in Kom.». Du bist draussen.', zustand: { channel: null, commMode: '' } }
        ]
    },
    {
        id: 'menue_zurueck',
        titel: 'Zurück im Menü',
        schritte: [
            { target: 'softkeys', text: 'Sobald du in einem Menü bist, steht links «Zurück».', zustand: { pendingMode: 'G', screen: 'input' } },
            { target: 'selectorD', text: 'Die linke Taste bringt dich einen Schritt zurück, ohne etwas auszuwählen.', zustand: { pendingMode: 'G', screen: 'input' } }
        ]
    },
    {
        id: 'sprechen',
        titel: 'Sprechen',
        schritte: [
            { target: 'ptt', text: 'Halte die Sprechtaste gedrückt, sprich, und lass erst danach wieder los.', zustand: { channel: '9003', commMode: 'D' } },
            { target: 'info', text: 'Solange du sendest, steht im Display ein «T».', zustand: { channel: '9003', commMode: 'D', isTransmitting: true } },
            { target: 'battery', text: 'Dabei sinkt der Akku. Sende nur, solange du sprichst.', zustand: { channel: '9003', commMode: 'D', isTransmitting: true, battery: 46 } }
        ]
    },
    {
        id: 'ausschalten',
        titel: 'Gerät ausschalten',
        schritte: [
            { target: 'power', text: 'Halte die Ein-/Aus-Taste zwei Sekunden gedrückt.' },
            { target: 'screen', text: 'Das Gerät fragt nach, ob es ausschalten soll.', zustand: { screen: 'confirmOff' } },
            { target: ['selectorD', 'selectorG'], text: 'Antworte über die beiden Tasten: links «Ja», rechts «Nein».', zustand: { screen: 'confirmOff' } }
        ]
    }
]
